export default __webpack_public_path__ + "static/media/digitalocean.6d3cc12a.svg";